<template>
  <nav
    v-if="menuItems && menuItems.length"
    ref="nav"
  >
    <div
      ref="inner"
      class="inner"
    >
      <ul ref="items">
        <a
          v-for="({ href, text } = {}, idx) in menuItems"
          :key="idx"
          :ref="selectedMenuItem === href ? 'active' : 'not-active' "
          :href="href"
          :class="{ 'active--link': selectedMenuItem === href }"
          @click="$emit('clickItem', { href, text })"
        >
          <li>{{ text }}</li>
        </a>
      </ul>
    </div>
  </nav>
</template>

<script>
  export default {
    name: 'ZgSubMenu',
    props: {
      menuItems: {
        type: Array,
        required: true,
        validator: menuItems => menuItems.filter(item => (item.href && item.text)).length === menuItems.length,
        default: () => []
      },
      selectedMenuItem: {
        type: String,
        required: false,
        default: ''
      }
    },
    data: () => ({
      horizontalScroll: 0
    }),
    mounted () {
      setTimeout(() => {
        this.setHorizontalScroll()
      }, 300)
    },
    methods: {
      setHorizontalScroll () {
        const navOffsetWidth = this.$refs?.nav?.offsetWidth
        const innerOffsetWidth = this.$refs?.inner?.offsetWidth
        const itemsScrollWidth = this.$refs?.items?.scrollWidth

        if (itemsScrollWidth <= navOffsetWidth) return

        const activeItem = this.$refs?.nav?.querySelector('.active--link')
        const activeItemOffset = activeItem?.offsetLeft
        const left = activeItemOffset - ((navOffsetWidth - innerOffsetWidth) / 2)

        this.$refs.nav.scroll({
          left,
          top: 0,
          behavior: 'smooth'
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  nav {
    overflow-x: scroll;
    background-color: color(brand-100);
    padding: rhythm(xsmall) rhythm(small) 0;
    transition: all 0.3s ease;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE 10+ */

    &::-webkit-scrollbar {
      /* WebKit */
      display: none;
    }

    .inner {
      display: flex;
      max-width: rem(966px);
      width: 100%;
      margin: 0 auto;
    }

    ul {
      display: flex;
      margin: 0;
      padding: 0;
    }

    a {
      @include type-title-xxs;

      font-weight: font-weight(bold);

      white-space: nowrap;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: rem(11px) rem(12px) rem(19px);
      list-style: none;
      border-bottom: none;
      border-radius: rhythm() rhythm() 0 0;
      margin: 0;

      &.active--link {
        background-color: color(white);
      }

      &:hover {
        background-color: color(white);
        color: color(brand-500);
      }
    }
  }
</style>
